import React from "react";
import i18n from "@/i18n";
import FilePreviewComponent from "@/components/FilePreviewComponent/FilePreviewComponent";
import { AssetTypes } from "@/model/AssetTypes";
import {
  VacancyApplicant,
  VacancyApplication,
} from "../../../model/VacancyApplicant.interface";

type Props = {
  application: VacancyApplication;
  applicant: VacancyApplicant;
  renderGuarantor?: boolean;
};

// TODO SJ: show no documents if no attachments are present

const VacancyApplicantAttachmentPart = (props: Props) => {
  const { application, applicant, renderGuarantor = false } = props;

  const applicantData = renderGuarantor ? applicant.guarantor : applicant;

  const proofOfIncomeAttachments = applicantData.proofOfIncome || [];

  const personalidAttachments = Array.isArray(applicantData.personalId)
    ? applicantData.personalId?.filter((p) => p !== null)
    : applicantData.personalId
    ? [applicantData.personalId]
    : [];

  const creditReportAttachments = applicantData.creditReport || [];
  const additionalAttachments = applicantData.additionalAttachments || [];

  const rentCoverageCertificateAttachments = Array.isArray(
    applicantData.rentCoverageCertificate
  )
    ? applicantData.rentCoverageCertificate?.filter((p) => p !== null)
    : applicantData.rentCoverageCertificate
    ? [applicantData.rentCoverageCertificate]
    : [];

  const hasAnyDocument =
    proofOfIncomeAttachments?.length > 0 ||
    personalidAttachments?.length > 0 ||
    creditReportAttachments?.length > 0 ||
    additionalAttachments?.length > 0 ||
    rentCoverageCertificateAttachments?.length > 0;

  const renderAttachments = () => {
    return (
      <>
        {personalidAttachments.length > 0 && (
          <div>
            <div className="__h3">
              {i18n.t(
                "apTemplate:Vacancy.Applicant.Attachments.PersonalId",
                "Ausweisdokumente"
              )}
            </div>
            {personalidAttachments?.map((p) => {
              return (
                <FilePreviewComponent
                  type="cdn"
                  asset={application}
                  assetField={`${
                    p.migrationFieldName
                      ? p.migrationFieldName
                      : "data.personalId"
                  }`}
                  assetType={`${
                    p.migrationAssetName
                      ? p.migrationAssetName
                      : AssetTypes.ActivityRelated.VacancyApplication
                  }`}
                  cdnID={p.linkToCdn}
                  height={60}
                  width={60}
                  hasFolderPermissions
                  dimension="thumb"
                />
              );
            })}
          </div>
        )}
        {proofOfIncomeAttachments.length > 0 && (
          <div>
            <div className="__h3">
              {i18n.t(
                "apTemplate:Vacancy.Applicant.Attachments.ProofOfIncome",
                "Einkommensnachweise"
              )}
            </div>
            {proofOfIncomeAttachments?.map((p) => {
              if (!p) {
                return null;
              }
              return (
                <FilePreviewComponent
                  type="cdn"
                  asset={application}
                  assetField={`${
                    p.migrationFieldName
                      ? p.migrationFieldName
                      : "data.proofOfIncome"
                  }`}
                  assetType={`${
                    p.migrationAssetName
                      ? p.migrationAssetName
                      : AssetTypes.ActivityRelated.VacancyApplication
                  }`}
                  cdnID={p.linkToCdn}
                  height={60}
                  width={60}
                  hasFolderPermissions
                  dimension="thumb"
                />
              );
            })}
          </div>
        )}
        {creditReportAttachments.length > 0 && (
          <div>
            <div className="__h3">
              {i18n.t(
                "apTemplate:Vacancy.Applicant.Attachments.CreditReports",
                "Bonität"
              )}
            </div>
            {creditReportAttachments?.map((p) => {
              if (!p) {
                return null;
              }
              return (
                <FilePreviewComponent
                  type="cdn"
                  asset={application}
                  assetField={`${
                    p.migrationFieldName
                      ? p.migrationFieldName
                      : "data.creditReport"
                  }`}
                  assetType={`${
                    p.migrationAssetName
                      ? p.migrationAssetName
                      : AssetTypes.ActivityRelated.VacancyApplication
                  }`}
                  cdnID={p.linkToCdn}
                  height={60}
                  width={60}
                  hasFolderPermissions
                  dimension="thumb"
                />
              );
            })}
          </div>
        )}
        {rentCoverageCertificateAttachments.length > 0 && (
          <div>
            <div className="__h3">
              {i18n.t(
                "apTemplate:Vacancy.Applicant.Attachments.RentCoverageCertificate",
                "Bescheinigung Jobcenter"
              )}
            </div>
            {rentCoverageCertificateAttachments?.map((p) => {
              if (!p) {
                return null;
              }
              return (
                <FilePreviewComponent
                  type="cdn"
                  asset={application}
                  assetField={`${
                    p.migrationFieldName
                      ? p.migrationFieldName
                      : "data.rentCoverageCertificate"
                  }`}
                  assetType={`${
                    p.migrationAssetName
                      ? p.migrationAssetName
                      : AssetTypes.ActivityRelated.VacancyApplication
                  }`}
                  cdnID={p.linkToCdn}
                  height={60}
                  width={60}
                  hasFolderPermissions
                  dimension="thumb"
                />
              );
            })}
          </div>
        )}
        {additionalAttachments.length > 0 && (
          <div>
            <div className="__h3">
              {i18n.t(
                "apTemplate:Vacancy.Applicant.Attachments.Other",
                "Sonstige Dokumente"
              )}
            </div>
            {additionalAttachments?.map((p) => {
              if (!p) {
                return null;
              }
              return (
                <FilePreviewComponent
                  type="cdn"
                  asset={application}
                  assetField={`${
                    p.migrationFieldName
                      ? p.migrationFieldName
                      : "data.additionalAttachments"
                  }`}
                  assetType={`${
                    p.migrationAssetName
                      ? p.migrationAssetName
                      : AssetTypes.ActivityRelated.VacancyApplication
                  }`}
                  cdnID={p.linkToCdn}
                  height={60}
                  width={60}
                  hasFolderPermissions
                  dimension="thumb"
                />
              );
            })}
          </div>
        )}
      </>
    );
  };

  return (
    <div>
      <div className="__h3 padding-top-10">
        {i18n.t("apTemplate:Vacancy.Applicant.Label.Attachments", "Dokumente")}
      </div>
      <div className="__grid __grid-cols-3 __grid-gap-10 __justify-items-start padding-top-10 __align-items-start">
        {!hasAnyDocument ? (
          <div className="__sub-text">
            {i18n.t(
              "apTemplate:Vacancy.Applicant.Attachments.NoDocuments",
              "Keine Dokumente vorhanden"
            )}
          </div>
        ) : (
          renderAttachments()
        )}
      </div>
    </div>
  );
};

export default VacancyApplicantAttachmentPart;
